/* @flow */
import * as React from 'react';
import type { Usage, SaveUsageParams, SimplifiedTrack } from 'types';
import styles from './styles.module.scss';
// import UsageInfo from 'components/UsageInfo';
import UsageForm from 'forms/UsageForm';
import protonesUtils from 'utils/protones';

type Props = {
  usage: Usage,
  track: SimplifiedTrack,
  isReadOnlyUsage?: boolean,
  isWorklistItemUsage?: boolean,
  onSave?: (params: SaveUsageParams) => any,
  onCreateProduction?: () => mixed,
  isLoading?: boolean,
};

const TrackListRowAccordionUsage = ({
  isLoading = false,
  isReadOnlyUsage = false,
  isWorklistItemUsage = false,
  onCreateProduction,
  onSave,
  track,
  usage,
}: Props) => {
  const initialValues = protonesUtils.getUsageFormValuesFromUsage(usage);
  return (
    <div className={styles.container}>
      <UsageForm
        form={`worklistItemUsage_${track.id}`}
        readOnly={isReadOnlyUsage}
        initialValues={initialValues}
        isLoading={isLoading}
        isWorklistItemUsage={isWorklistItemUsage}
        actionButtonsVisible={isWorklistItemUsage}
        save={onSave}
        onCreateProduction={onCreateProduction}
      />
    </div>
  );
};

export default TrackListRowAccordionUsage;
